import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ICS from 'vue-ics'
import { BFormSelect, BImgLazy, BIconChevronRight, BIconChevronLeft, BIconCursor, BIconFullscreenExit, BIconAspectRatio, BIconBrightnessHighFill, BIconCircle, BIconArrowLeft, BIconArrowRight } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'

Vue.component('b-form-select', BFormSelect)
Vue.component('b-img-lazy', BImgLazy)
Vue.component('b-icon-chev-right', BIconChevronRight)
Vue.component('b-icon-chev-left', BIconChevronLeft)
Vue.component('b-icon-cursor', BIconCursor)
Vue.component('b-icon-sun', BIconBrightnessHighFill)
Vue.component('b-icon-circle', BIconCircle)
Vue.component('b-icon-arrow-left', BIconArrowLeft)
Vue.component('b-icon-arrow-right', BIconArrowRight)
Vue.component('b-icon-aspect-ratio', BIconAspectRatio)
Vue.component('b-icon-fs-exit', BIconFullscreenExit)

Vue.use(ICS)

import { BModal } from 'bootstrap-vue'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
Vue.component('b-modal', BModal)

import ElementObserver from './directives/observer'
Vue.directive('observer', ElementObserver);

import matrix3dTransform from "@/directives/matrix3dTransform"
Vue.directive('matrix3d', matrix3dTransform);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')

